import adminApiClient from '../api/adminApiClient'
import type { DealerUser, DealerUserCreateRequest } from '../types'

// Пользователи портала дилера: создаются админом, вход по приглашению на email

export async function getDealerUsers(branchId: string): Promise<DealerUser[]> {
  const { data } = await adminApiClient.get<DealerUser[]>(`/branches/${branchId}/dealer-users`)
  return data
}

// создание сразу отправляет приглашение на email (409 EMAIL_TAKEN, 422 BRANCH_ARCHIVED)
export async function createDealerUser(branchId: string, body: DealerUserCreateRequest): Promise<DealerUser> {
  const { data } = await adminApiClient.post<DealerUser>(`/branches/${branchId}/dealer-users`, body)
  console.log(`[INFO] Dealer user created — branchId: ${branchId}, id: ${data.id}`)
  return data
}

// повторная отправка приглашения (409 USER_ALREADY_ACTIVE)
export async function resendDealerUserInvite(branchId: string, userId: string): Promise<DealerUser> {
  const { data } = await adminApiClient.post<DealerUser>(`/branches/${branchId}/dealer-users/${userId}/invite`)
  console.log(`[INFO] Dealer user invite resent — id: ${userId}`)
  return data
}

export async function disableDealerUser(branchId: string, userId: string): Promise<DealerUser> {
  const { data } = await adminApiClient.post<DealerUser>(`/branches/${branchId}/dealer-users/${userId}/disable`)
  console.log(`[INFO] Dealer user disabled — id: ${userId}`)
  return data
}

// 409 EMAIL_TAKEN — email успели занять, пока пользователь был отключён
export async function enableDealerUser(branchId: string, userId: string): Promise<DealerUser> {
  const { data } = await adminApiClient.post<DealerUser>(`/branches/${branchId}/dealer-users/${userId}/enable`)
  console.log(`[INFO] Dealer user enabled — id: ${userId}`)
  return data
}

// админ задаёт пароль сам: действует сразу, сессии пользователя завершаются (400 PASSWORD_TOO_SHORT, 422 USER_DISABLED)
export async function setDealerUserPassword(branchId: string, userId: string, password: string): Promise<DealerUser> {
  const { data } = await adminApiClient.post<DealerUser>(`/branches/${branchId}/dealer-users/${userId}/password`, { password })
  console.log(`[INFO] Dealer user password set — id: ${userId}`)
  return data
}

// письмо со ссылкой сброса пароля (409 USER_NOT_ACTIVATED, 422 USER_DISABLED, 502 EMAIL_SEND_FAILED)
export async function sendDealerUserPasswordReset(branchId: string, userId: string): Promise<DealerUser> {
  const { data } = await adminApiClient.post<DealerUser>(`/branches/${branchId}/dealer-users/${userId}/reset-password`)
  console.log(`[INFO] Dealer user password reset sent — id: ${userId}`)
  return data
}
